import * as React from 'react'
import { cn } from '@/lib/utils'

// DetailSection — design detail.jsx:9-16. mt-6 section with an 11/700/0.5
// muted microlabel (mb 9). `action` renders right-aligned on the label row.
export interface DetailSectionProps {
  label: React.ReactNode
  action?: React.ReactNode
  className?: string
  children: React.ReactNode
}

export function DetailSection({ label, action, className, children }: DetailSectionProps) {
  return (
    <section className={cn('mt-6', className)}>
      <div className="mb-[9px] flex items-center justify-between gap-2">
        {/* h2, not a div: the detail page is ~2500px tall on a phone and had
            exactly ONE heading in the whole document, so screen-reader heading
            navigation had nothing to jump between. Styling is unchanged. */}
        <h2 className="text-[11.5px] font-bold uppercase tracking-[0.5px] text-ink-muted">{label}</h2>
        {action}
      </div>
      {children}
    </section>
  )
}
